import React from "react";
import { Box, Typography, Stack } from "@mui/material";
// import RocketryButton from "../components/RocketryButton";
import Footer from "../sections/Footer";
// import {Events} from "../sections/Events";
import Header from "../Header";


function About() {
    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",

            }}
        >
            <title>About City St. Georges, University of London Aerospace Society</title>
            <Header />
            <Stack

                direction="column"
                spacing={5}
                sx={{
                    scrollSnapAlign: "start",
                    backgroundColor: "#A8ACB0",
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                }}
            >

                <Box>
                    <Typography variant={"h4"} sx={{mb: 2}} color={""}>
                        About Us
                    </Typography>

                    <Typography variant={"body1"} sx={{mb: 2,p:2}} align={"justify"}>
                        Ready to launch with us? Become a member today.
                        No matter your background or level of expertise, the City St George's, University of London Rocketry Society welcomes everyone with open arms. Whether you're a seasoned rocket scientist or a curious beginner, there's a place for you here.



                        Together, we'll explore the cosmos and embark on a journey that's truly out of this world. Ready to launch your passion for aerospace? Join us, and together, let's reach for the stars!



                        Follow us on @cityaerospace on instagram for updates, events, and behind-the-scenes rocketry adventures. For inquiries, contact us on the whatsapp groupchat!

                        Contact us at rocketrysoc@city.ac.uk
                        <br />
                        Follow us on socials: @cityaerospace
                    </Typography>


                </Box>


            </Stack>

            <Footer />

        </Box>
    );
}

export default About;